import { DollarIcon } from "@icons";
import {
    InstitutionIcon,
    type InstitutionIconProps,
    type InstitutionKey,
} from "./InstitutionIcon";

/**
 * A financial account's logo once resolved: a known brand, a logo URL, the
 * manual-account glyph, or `null` for the bank glyph.
 */
export type InstitutionIconResolution =
    | { institution: InstitutionKey }
    | { src: string }
    | { fallback: "manual" }
    | null;

interface ResolvedInstitutionIconProps extends Pick<
    InstitutionIconProps,
    "size" | "label" | "className"
> {
    icon: InstitutionIconResolution;
}

/** Draws a resolved logo: the brand or URL, a dollar glyph for manual accounts, else the bank glyph. */
export const ResolvedInstitutionIcon = ({
    icon,
    ...iconProps
}: Readonly<ResolvedInstitutionIconProps>) => {
    if (icon === null) {
        return <InstitutionIcon {...iconProps} />;
    }
    if ("fallback" in icon) {
        return <InstitutionIcon {...iconProps} fallback={<DollarIcon />} />;
    }
    return <InstitutionIcon {...iconProps} {...icon} />;
};
